/**
 * Pushes the given object to the
 * window.dataLayer using the given event Name
 * @param name
 * @param object
 */
function pushLayer(name, object) {
    if (!window.dataLayer) {
        window.dataLayer = [];
    }
    window.dataLayer.push({
        'event': name,
        ...object
    });
}

/**
 * Track a location focus event
 * @param location
 */
export function trackingPushLocationFocus(location) {
    return;
    pushLayer('posfinder_show_detail', {
        'location': location.title,
        'tab': location.type,
        'zip': location.zip,
    });
}

/**
 * Track click on the location gMap link
 * @param location
 */
export function trackingPushLocationGmapLink(location) {
    pushLayer('posfinder_gmap_redirect', {
        'location': location.title,
        'tab': location.type,
        'zip': location.zip,
    });
}

/**
 * Track the location search form
 * @param query
 */
export function trackingPushLocationSearch(query) {
    pushLayer('posfinder_search_query', {
        'query': query?.query || "",
        'radius': query.filter,
        'lat': query?.coords?.lat || "",
        'lon': query?.coords?.lon || ""
    });
}
